




















































import Vue from 'vue';
import { Model, Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';

@Component({
	componentId: 'C020',
	components: {},
	inheritAttrs: false
})
export default class TextInput extends Vue {
	@Prop(String)
	protected readonly id!: string;

	@Prop({ type: String, default: '' })
	protected readonly name!: string;

	@Prop(String)
	protected readonly label?: string;

	@Prop(String)
	protected readonly fieldDescription?: string;

	@Prop({ type: String, default: 'text' })
	protected readonly type!: string;

	@Prop({ type: Boolean, default: false })
	protected readonly multiline!: boolean;

	@Prop({ type: String, default: '' })
	protected readonly dynamicClass!: string;

	@Model('input', { type: String, default: '' })
	protected value!: string;

	@Prop({ type: Boolean, default: false })
	protected readonly hasError!: boolean;

	@Prop({ type: Boolean, default: false })
	protected isFilled!: boolean;

	@Prop({ type: Object, default: () => ({}) })
	protected readonly labelStyle!: object;

	protected internalLabelStyle: object = {};

	protected labelLong: boolean = false;

	protected labelStyleNotOver: boolean = false;

	protected mounted(): void {
		this.internalLabelStyle = { ...this.labelStyle };
		this.updateLabelStyle();
		if (this.label) {
			const label = this.$refs.fieldLabel as HTMLElement;
			if (label) {
				const isMultiLine = label.scrollHeight > label.clientHeight + 2;
				if (isMultiLine) {
					this.labelLong = true;
					this.labelStyleNotOver = true;
				}
				if (this.name.includes('screeningQuestionName-')) {
					this.labelLong = true;
					this.labelStyleNotOver = true;
				}
			}
		}
		if (this.fieldDescription) {
			this.labelStyleNotOver = true;
		}
	}

	protected updateLabelStyle(): void {
		this.$nextTick(() => {
			// find the closest parent element with the class "m-sf-job-application"
			let isMSfJobApplication: HTMLElement | null = this.$el as HTMLElement;
			while (isMSfJobApplication && !isMSfJobApplication.classList.contains('m-sf-job-application')) {
				isMSfJobApplication = isMSfJobApplication.parentElement;
			}
			if (isMSfJobApplication) {
				const inputElement = this.$refs.input as HTMLInputElement | HTMLTextAreaElement;
				if (inputElement) {
					this.internalLabelStyle = {
						...this.internalLabelStyle,
						height: `${inputElement.clientHeight}px`
					};
				}
			}
		});
	}

	public setError(error: string): void {
		(this.$refs.input as HTMLInputElement).setCustomValidity(error);
		this.updateLabelStyle();
	}

	public resetError(): void {
		(this.$refs.input as HTMLInputElement).setCustomValidity('');
		this.updateLabelStyle();
	}

	protected get inputId(): string {
		return `${this.id}-input`;
	}

	protected onInput(event: Event): void {
		this.$emit('input', (event.target as HTMLInputElement).value);

		this.isFilled = (this.$refs.input as HTMLInputElement).value.trim().length > 0;
		this.updateLabelStyle();
	}

	@Watch('value', { immediate: true })
	protected onValueChange(value: string): void {
		this.isFilled = value.trim().length > 0;
		this.updateLabelStyle();
	}

	@Watch('labelStyle', { immediate: true, deep: true })
	protected onLabelStyleChange(newStyle: object): void {
		this.internalLabelStyle = { ...newStyle };
		this.updateLabelStyle();
	}

	@Watch('label', { immediate: true })
	protected onLabelChange(newLabel: string): void {
		this.labelLong = newLabel.length > 90;
	}
}
